import { fieldValidationMessages } from 'app/constants';
import { ExportTuneCoreReleaseFormValues } from './types';

export const defaultValues: ExportTuneCoreReleaseFormValues = {
  mainArtist: '',
  genre: null,
  language: null,
  recordingLocation: '',
};

export const tuneCoreExportFormErrorMessages = {
  errors: {
    mainArtist: {
      maxLength: (props: [string, { maxLength: number }]) => {
        return fieldValidationMessages.MAX_CHAR(props[1].maxLength);
      },
    },
    recordingLocation: {
      maxLength: (props: [string, { maxLength: number }]) => {
        return fieldValidationMessages.MAX_CHAR(props[1].maxLength);
      },
    },
  },
};
